import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/home/index.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    // {
    //   path: '/servers',
    //   component: () => import('../pages/servers/index.vue'),
    //   name: 'servers',
    // },
    {
      path: '/pbf',
      component: () => import('../pages/pbf/index.vue'),
      name: 'pbf',
    },
    {
      path: '/about',
      component: () => import('../pages/about/index.vue'),
      name: 'about',
    },
    {
      path: '/news',
      component: () => import('../pages/news/index.vue'),
      name: 'news',
    },
    {
      path: '/detail_3',
      component: () => import('../pages/news/detail_3.vue'),
      name: 'detail3',
      hidden: true,
    },
    {
      path: '/detail_4',
      component: () => import('../pages/news/detail_4.vue'),
      name: 'detail4',
      hidden: true,
    },
    {
      path: '/pnyqx',
      component: () => import('../pages/pnyqx/index.vue'),
      name: 'pnyqx',
    },
	{
		path: '/pnsc',
		component: () => import('../pages/pnsc/index.vue'),
		name: 'pnsc',
	},
	{
		path: '/jjfa',
		component: () => import('../pages/jjfa/index.vue'),
		name: 'jjfa',
	},
	{
		path: '/platform',
		component: () => import('../pages/platform/index.vue'),
		name: 'platform',
	},
    
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js